module.exports = __webpack_public_path__ + "static/pcsLogo-47964e0baedb5075d0532235b08735c7.png";